import React, { Component } from 'react';
import { Trans } from "react-i18next";

import DropIn from "braintree-web-drop-in-react";
import axios from 'axios';
import Loader from 'react-loader-spinner';

import ls from "local-storage";
import { options } from "../../config/options";

import "../../config/i18n";
import { withTranslation } from "react-i18next";
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import ReactHtmlParser from 'react-html-parser';

import ReCAPTCHA from "react-google-recaptcha";
import { NavLink } from 'react-router-dom';

const recaptchaRef = React.createRef();

 const captcha_site_key = "6LeYbcckAAAAABD2QJabSkxLbrEfSrdhEna8oPyU";
//const captcha_site_key = "6Ldn-f0ZAAAAAPiY3xwpLPQQsF1-tWu6v4qCwFQW";

class Cibpay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      api_url: localStorage.getItem('api_url'),
      langKey: ls.get('LangValue'),
      termsCheck: false,
      showModal: false,
      modal5: false,
    }
  }

  async componentDidMount() {
    console.log('........name,na', this.props)

    console.log('........name,na', this.props.location.state)
    //   if(!this.props || this.props.location.package_id===undefined){
    //      this.props.history.push("/app/Profile"); 
    //      return false;
    //     }

    //     let selected_boostpremium=this.props.location.package_id || JSON.parse(localStorage.getItem('selected_boostpremium'));
    //     let price=this.props.location.price || JSON.parse(localStorage.getItem('boostpremium_price'));
    //     let currency=this.props.location.currency || JSON.parse(localStorage.getItem('currency'));
    //      console.log('package_id',this.props.location.package_id+"price="+this.props.location.price+"cur="+this.props.location.currency);
    //      this.setState({
    //         selected_boostpremium:selected_boostpremium,
    //         price:price,
    //         currency:currency
    //      });    
  }

  togglecheckbox = () => {
    this.setState({
      termsCheck: !this.state.termsCheck,
    });
  }
  closeModal(tabId) {
    this.setState({
      [tabId]: false
    });
  }
  componentWillMount() {

    //alert(this.state.buybutton) 
  }
  makecibpayment = () => {
    const { amount, purchase_type, currency_code, wallet_balance_amount, wallet_amount, minus_wallet_amount, take_from_wallet } = this.props.location.state;

    var item_id = 0;
    // const recaptchaValue = recaptchaRef.current.getValue();
    const recaptchaValue = 1;
    if (this.state.termsCheck == true && recaptchaValue !== '') {
      let data = new FormData();
      data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
      data.append('language', this.state.langKey);
      data.append('currency_code', currency_code);
      data.append('amount', amount);
      data.append('purchase_type', purchase_type);
      if (purchase_type == 'premium') {
        item_id = JSON.parse(localStorage.getItem('selected_premium'));
      }
      else if (purchase_type == 'boost') {
        item_id = JSON.parse(localStorage.getItem('selected_boostpremium'));
      }
      else if (purchase_type == 'superlike') {
        item_id = JSON.parse(localStorage.getItem('selected_superlikepremium'));
      }
      else if (purchase_type == 'banner') {
        item_id = JSON.parse(localStorage.getItem('banner_id'));
      }
      console.log(this.state.api_url);

      data.append('item_id', item_id);
      axios({
        method: 'post',
        url: this.state.api_url + 'createcibpayurl',
        data: data,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      }).then(res => {
      //  console.log('DAS',res);return false;
        if (res.status === 200) {
          console.log("kkk");
          
          if (res.data.status == 'false') {
            this.setState({
              message: res.data.message,
              modal5: true,
            });
          }

          if (res.data.status !== false) {
            console.log("1kkk");

            if (res.data.url && res.data.url !== '') {
              console.log("2kkk");
              localStorage.setItem('for_cib_payment_wallet_amount', wallet_amount);
              localStorage.setItem('for_cib_payment_minus_wallet_amount', minus_wallet_amount);
              localStorage.setItem('for_cib_payment_wallet_balance_amount', wallet_balance_amount);
              localStorage.setItem('for_cib_payment_payable_amount', amount);
              localStorage.setItem('for_cib_payment_take_from_wallet', take_from_wallet);
              //localStorage.setItem('for_stripe_payment_auto_renewal', this.state.auto_renewal && this.state.auto_renewal);
              console.log('......url', res.data.url);
              window.location.href = res.data.url;
              // window.open(
              //     res.data.url,
              //     '_blank' // <- This is what makes it open in a new window.
              //   );
            }
          } else {
            this.setState({
              message: 'Something went wrong, try again!',
              modal5: true,
            });
          }
        }

        else {
                 // console.log('ERROR',res)
          this.setState({
            message: 'Something went wrong, try again!',
            modal5: true,
          });
        }
      });
    } else if (recaptchaValue == '') {
      this.setState({
        message: 'You must verify the captcha',
        modal5: true,
      });
    }
    else {
      this.setState({
        message: 'Kindly Accept Terms and Conditions!',
        modal5: true,
      });
    }
  }
  render() {

    // const { id, name, email } = this.props.location.state;
    const { amount, purchase_type, currency_code, terms, termsdes } = this.props.location.state;

    var style = {
      zIndex: 10,
      backgroundColor: "white",
      height: "100vh",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      overflowY: "hidden"
    };

    return (
      <div className="setting-page">
        <div className="profile-header-top stickyProfileHead justify-content-between apd15 apr0 apl0 white-bg ">
          <div className="heading-left-top d-flex">
            <span className="arrow-center align-self-center ml-1 bold-font">
              <Trans i18nKey="CIB">CIB</Trans> <Trans i18nKey="Payment">Payment</Trans>
            </span>
          </div>
          <div className="p-4">
            <section>
              <div class="d-flex align-items-center justify-content-center cibBorder">
                <div>
                  <p class="fsm mb-0"><Trans i18nKey="Balance">Balance</Trans></p>
                  <p class="bold-font mb-0">{amount} {currency_code}</p>
                </div>
              </div>
              <div className="form-group" >

                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={captcha_site_key}
                  onChange={token => this.setState({ token })}
                />
              </div>
              <div>
                <div class="moneyStatus d-flex">
                  <input
                    type="checkbox"
                    name="rGroup"
                    id="w1"
                    onChange={this.togglecheckbox}
                    checked={this.state.termsCheck}
                  />
                  <label class="" for="w1"></label>
                  <p>
                    <NavLink to={`/helpmain`} target="_blank">
                      <Trans i18nKey="Accept">Accept</Trans>
                      <span className='cibterms'>
                        <Trans i18nKey="TermsandConditions">Terms and Conditions</Trans>
                      </span>
                    </NavLink>
                  </p>

                  {/* <p><Trans i18nKey="Accept">Accept</Trans> <span className='cibterms' onClick={() => this.setState({ showModal: true })}><Trans i18nKey="TermsandConditions">Terms and Conditions</Trans></span></p> */}
                </div>
              </div>
            </section>
            <div className='d-flex w-100 mt-5 justify-content-between'>
              <NavLink to={{
                pathname: '/app/Profile'
              }}>
                <button class="btn-cancel">
                  <Trans i18nKey="Cancel">Cancel</Trans></button>
              </NavLink>
              <button class="btn-common" onClick={this.makecibpayment}>
              <Trans i18nKey="EDAHABIA ">EDAHABIA </Trans>
                <img src={require("../../assets/img/cib.jpg")} alt="" className="cib" />
                <Trans i18nKey="Validate">Validate</Trans></button>
            </div>
          </div>
          <Modal isOpen={this.state.showModal} toggle={this.closeModal.bind(this, 'showModal')} className="premiumPopup vertically-center apd5">
            <ModalHeader toggle={this.closeModal.bind(this, 'showModal')}><h4 class="modal-title" style={{ 'marginTop': "10px" }}><Trans i18nKey={terms}>{terms}</Trans></h4></ModalHeader>
            <ModalBody>
              <div className="modal-body">
                <div>
                  {ReactHtmlParser(termsdes)}
                </div>
                <div class="d-flex justify-content-end">
                  <div class="mr-3"><button class="border-0 bg-white pink-color" onClick={this.closeModal.bind(this, 'showModal')}><Trans i18nKey="Ok">Ok</Trans></button></div>
                </div>
              </div>
            </ModalBody>
          </Modal>
          <Modal isOpen={this.state.modal5} toggle={this.closeModal.bind(this, 'modal5')} className="premiumPopup vertically-center apd5">
            <ModalHeader toggle={this.closeModal.bind(this, 'modal5')}><h4 class="modal-title" style={{ 'marginTop': "10px" }}><Trans i18nKey={this.state.message}>{this.state.message}</Trans></h4></ModalHeader>
            <ModalBody>
              <div className="modal-body">
                <div class="d-flex justify-content-end">
                  <div class="mr-3"><button class="border-0 bg-white pink-color" onClick={this.closeModal.bind(this, 'modal5')}><Trans i18nKey="Ok">Ok</Trans></button></div>
                </div>
              </div>
            </ModalBody>
          </Modal>
        </div>
      </div>
    );
  }
}

export default withTranslation("translations")(Cibpay);